import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AppContext } from '../../../hooks/auth/useAppContext';
import { useStandardCall } from '../../../hooks/useStandardCall';
import SingleInput from '../../../components/SingleInput';
import { LocalLoading } from '../../../components/Loading';
import { toast } from 'react-toastify';

export function TechnicalProfile({ myProfile, role = 'PLAYER' }) {
  /* const { TechnicalProfile } = myProfile; */
  const [TechnicalProfile, setTechnicalProfile] = useState(
    myProfile.TechnicalProfile
  );
  const stdCall = useStandardCall();
  const appContext = useContext(AppContext);
  const Locale = appContext.locale;
  const lookup = TheApp.Lookup[Locale];
  const [loading, setLoading] = useState(false);
  const [statusForm, setStatusForm] = useState(null);
  const [resource, setResourse] = useState(TheApp.Res);
  const [oneHandBackhand, setOneHandBackhand] = useState(TechnicalProfile.OneHandBackhand);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors }
  } = useForm({});
  
  useEffect(() => {
    if (statusForm) {
      if (statusForm?.success) {
        console.log('success technical');
        const toasts = toast.success(statusForm?.message);
      }
      if (!statusForm?.success) {
        console.log('fail technical');
        const toasts = toast.error(statusForm?.message);
      }
    }

  }, [statusForm]);



  const inputs = [
    {
      id: 'Height',
      label: ( resource["Form.Height"] ?? 'Altezza in cm'),
      type: 'number',
      isDisabled: role === 'COACH' || role === 'TECH_DIRECTOR' ? true : false,
      defaultValue: TechnicalProfile.Height,
      validationSchema: {
        required:
          role === 'COACH' || role === 'TECH_DIRECTOR'
            ? null
            : resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
        min: { value: 1, message: (resource["Form.Height.Validation.Min"] ?? 'Altezza minima 100 cm') }
      },
      placeholder: (resource["Form.Height.Placeholder"] ??  'Inserisci la tua altezza in cm'),
      layout: 'col-lg-6',
      icon: 'fa fa-arrows-v'
    },
    {
      id: 'Weight',
      label: (resource["Form.Weight"] ?? 'Peso in Kg'),
      type: 'number',
      isDisabled: role === 'COACH' || role === 'TECH_DIRECTOR' ? true : false,
      defaultValue: TechnicalProfile.Weight,
      validationSchema: {
        required:
          role === 'COACH' || role === 'TECH_DIRECTOR'
            ? null
            : resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
      },
      placeholder: (resource["Form.Weight.Placeholder"] ?? 'Inserisci il tuo peso in kg'),
      layout: 'col-lg-6',
      icon: 'fa fa-balance-scale'
    },
    {
      id: 'fitp',
      label: ( resource["Form.FITPNumber"] ??  "N. Tessera FITP"),
      type: 'text',
      isDisabled: role === 'COACH' || role === 'TECH_DIRECTOR' ? true : false,
      defaultValue: myProfile.FITP,
      validationSchema:{
        pattern: {
          value: /^[0-9]*$/i,
          message: ( resource["Form.FITPNumber.Pattern"] ??  "Numero tessera FITP non valido"),
        }
      },
      placeholder: (resource["Form.FITPNumberPlaceholder"] ??  "Inserisci il numero della tua tessera"),
      icon: 'fa fa-id-card',
      layout: 'col-lg-6'
    },
    {
      id: 'FITPExpireDate',
      isDisabled: role === 'COACH' || role === 'TECH_DIRECTOR' ? true : false,
      label: ( resource["Form.FITPExpirationDate"] ?? "Scadenza tessera FITP"),
      type: 'date',
      defaultValue:  myProfile.FITPExpireDate,
      validationSchema: {
        pattern: {
          value: /^\d{4}-\d{2}-\d{2}$/,
          message: ( resource["Form.Pattern.Birthday"] ?? "Formato data non valido dd/mm/yyyy"),
        }
      },
      placeholder: (resource["Form.FITPExpirationDatePlaceholder"] ??  "Inserisci il numero della tua tessera"),
      icon: 'fa fa-calendar',
      layout: 'col-lg-6'
    },
    {
      id: 'DominantHand',
      type: 'radioGroup',
      label: (resource["Form.DominandHand"] ??  'Mano dominante'),
      layout: 'col-lg-6',

      defaultValue: TechnicalProfile.DominantHandLeft
        ? 'DominantHandLeft'
        : TechnicalProfile.DominantHandRight
        ? 'DominantHandRight'
        : null,
      inputs: [
        {
          id: 'DominantHandLeft',
          label: ( resource["Form.DominandHand.Left"] ?? 'Sinistra'),
          type: 'radio',
          group: 'DominantHand',
          defaultValue: TechnicalProfile.DominantHandLeft
        },
        {
          id: 'DominantHandRight',
          label: (resource["Form.DominandHand.Right"] ?? 'Destra'),
          type: 'radio',
          group: 'DominantHand',
          defaultValue: TechnicalProfile.DominantHandRight
        }
      ]
    },
    {
      id: 'OneHandBackhand',
      type: 'checkbox',
      onChangeCallback: handleOneHandBackhandChanged,
      label: (resource["Lookup.OneHandBackhandTrue"] ?? "Rovescio ad una mano"),
      defaultValue: oneHandBackhand,
      layout: 'col-lg-6'
      /* validationSchema: {
        required: 'Campo obbligatorio'
      } */
    },
    {
      id: 'Forehand',
      type: 'select',
      label: (resource["Form.Forehand"] ?? 'Diritto'),
      placeholder: (resource["Form.Forehand.Placeholder"] ?? 'Seleziona il tuo diritto'),
      defaultValue: TechnicalProfile.Forehand ?{
        value: TechnicalProfile.Forehand ,
        label: TechnicalProfile.Forehand
      } : "",
      // validationSchema: {
      //   required: 'Campo obbligatorio'
      // },
      options: {
        Items: lookup.LookupForehand
      },
      layout: 'col-lg-6'
    },
    {
      id: 'BackhandDominantHand',
      type: 'select',
      label: (resource["Form.BackhandDominantHand"] ?? 'Rovescio mano dominante'),
      placeholder: (resource["Form.Backhand.Placeholder"] ??  'Seleziona il tuo rovescio'),
      defaultValue: TechnicalProfile.BackhandDominantHand ? {
        value: TechnicalProfile.BackhandDominantHand,
        label: resource["Lookup.BackhandDominantHand." + TechnicalProfile.BackhandDominantHand] || TechnicalProfile.BackhandDominantHand
      } : "",
      options: {
        Items: lookup.LookupBackhandDominantHand
      },
      layout: 'col-lg-6'
    },
    {
      id: 'BackhandSecondaryHand',
      type: 'select',
      isDisabled: oneHandBackhand === true ? true : false,
      label: (resource["Form.NonBackhandDominantHand"] ?? 'Rovescio mano non dominante'),
      placeholder: (resource["Form.Backhand.Placeholder"] ??  'Seleziona il tuo rovescio'),
      defaultValue: TechnicalProfile.BackhandSecondaryHand ? {
        value: TechnicalProfile.BackhandSecondaryHand,
        label: resource["Lookup.BackhandSecondaryHand." + TechnicalProfile.BackhandSecondaryHand] || TechnicalProfile.BackhandSecondaryHand
      } : "",
      options: {
        Items: lookup.LookupBackhandSecondaryHand
      },
      layout: 'col-lg-6'
    },
    {
      id: 'Serve',
      type: 'select',
      label: (resource["Form.Serve"] ??  'Servizio'),
      placeholder: (resource["Form.Serve.Placeholder"] ??  'Seleziona il tuo servizio'),
      defaultValue: TechnicalProfile.Serve ? {
        value: TechnicalProfile.Serve,
        label: TechnicalProfile.Serve
      } : "",
      options: {
        Items: lookup.LookupServe
      },
      layout: 'col-lg-6'
    },
    {
      id: 'Volley',
      type: 'select',
      label: (resource["Form.Volley"] ?? 'Volée'),
      placeholder: (resource["Form.Volley.Placeholder"] ?? 'Seleziona la tua volée'),
      defaultValue: TechnicalProfile.Volley ? {
        value: TechnicalProfile.Volley,
        label: TechnicalProfile.Volley
      } : "",
      options: {
        Items: lookup.LookupVolley
      },
      layout: 'col-lg-6'
    },
    {
      id: 'Smash',
      type: 'select',
      label: (resource["Form.Smash"] ?? 'Smash'),
      placeholder: (resource["Form.Smash.Placeholder"] ??  'Seleziona il tuo smash'),
      defaultValue: TechnicalProfile.Smash ? {
        value: TechnicalProfile.Smash,
        label: TechnicalProfile.Smash
      } : "",
      options: {
        Items: lookup.LookupSmash
      },
      layout: 'col-lg-6'
    },
    {
      id: 'Level',
      type: 'select',
      label: (resource["Form.Level"] ?? 'Livello'),
      placeholder: (resource["Form.Level.Placeholder"] ?? 'Seleziona il tuo livello'),
      defaultValue: TechnicalProfile.Level ?{
        value: TechnicalProfile.Level,
        label: resource["Lookup.Level." + TechnicalProfile.Level]
      } : "",
      options: {
        Items: lookup.LookupLevel
      },
      layout: 'col-lg-6'
    },
    {
      id: 'Ranking',
      label: (resource["Form.Ranking"] ?? 'Ranking'),
      type: 'select',
      placeholder: (resource["Form.Ranking.Placeholder"] ?? 'Seleziona il tuo ranking'),
      defaultValue: TechnicalProfile.Ranking ? {
        value: TechnicalProfile.Ranking,
        label: TechnicalProfile.Ranking
      } : "",
      options: {
        Items: [
          { Value: '2.1', Label: '2.1' },
          { Value: '2.2', Label: '2.2' },
          { Value: '2.3', Label: '2.3' },
          { Value: '2.4', Label: '2.4' },
          { Value: '2.5', Label: '2.5' },
          { Value: '2.6', Label: '2.6' },
          { Value: '2.7', Label: '2.7' },
          { Value: '2.8', Label: '2.8' },
          { Value: '3.1', Label: '3.1' },
          { Value: '3.2', Label: '3.2' },
          { Value: '3.3', Label: '3.3' },
          { Value: '3.4', Label: '3.4' },
          { Value: '3.5', Label: '3.5' },
          { Value: '4.1', Label: '4.1' },
          { Value: '4.2', Label: '4.2' },
          { Value: '4.3', Label: '4.3' },
          { Value: '4.4', Label: '4.4' },
          { Value: '4.5', Label: '4.5' },
          { Value: '4.6', Label: '4.6' },
          { Value: '4NC', Label: '4NC' }
        ]
      },
      layout: 'col-lg-6'
    }
  ];

function handleOneHandBackhandChanged(e) {
    setOneHandBackhand(e);
    if (e === true) {
      setValue('BackhandSecondaryHand', "");
    }
}

  async function updateTechnicalInfo(data) {
    const {
      Height,
      Weight,
      DominantHand,
      OneHandBackhand,
      Forehand,
      BackhandDominantHand,
      BackhandSecondaryHand,
      Serve,
      Volley,
      Smash,
      Level,
      Ranking
    } = data;
    const rq =
      role === 'COACH' || role === 'TECH_DIRECTOR'
        ? {
          Role: role,
            UidPlayer: myProfile.Uid,
            TechnicalProfile: {
              Height,
              Weight,
              DominantHand,
              OneHandBackhand,
              Forehand: Forehand.value,
              DominantHandLeft:
                DominantHand === 'DominantHandLeft' ? true : false,
              DominantHandRight:
                DominantHand === 'DominantHandRight' ? true : false,
              BackhandDominantHand: BackhandDominantHand.value,
              BackhandSecondaryHand: BackhandSecondaryHand.value,
              Serve: Serve.value,
              Volley: Volley.value,
              Smash: Smash.value,
              Level: Level.value,
              Ranking: Ranking.value,
              HeightUnit: 'cm',
              WeightUnit: 'kg'
            }
          }
        : {
          Role: role,
            TechnicalProfile: {
              Height,
              Weight,
              DominantHand,
              OneHandBackhand,
              Forehand: Forehand.value,
              DominantHandLeft:
                DominantHand === 'DominantHandLeft' ? true : false,
              DominantHandRight:
                DominantHand === 'DominantHandRight' ? true : false,
              BackhandDominantHand: BackhandDominantHand.value,
              BackhandSecondaryHand: BackhandSecondaryHand.value,
              Serve: Serve.value,
              Volley: Volley.value,
              Smash: Smash.value,
              Level: Level.value,
              Ranking: Ranking.value,
              HeightUnit: 'cm',
              WeightUnit: 'kg'
            }
          };
    /* console.log(rq); */
    appContext._setters._setLoading(true);
    stdCall.post('app/updatetechnicalprofile', rq, (rs) => {
      if (rs.Success) {

        if (role !== 'COACH' && role !== "TECH_DIRECTOR") {
          const sub = appContext.userSession.userData.myProfile.Subscriptions;
          const newProfile = {
            ...appContext.userSession.userData.myProfile,
            TechnicalProfile: rs.TechnicalProfile,
            Subscriptions: sub
          };
          appContext._setters._setProfile(newProfile);
        }
        setTechnicalProfile(rs.TechnicalProfile);
        setStatusForm({
          status: true,
          success: true,
          message: 'Profilo aggiornato correttamente'
        });
      } else {
        setStatusForm({
          status: true,
          success: false,
          message: "Errore durante l'aggiornamento del profilo"
        });
      }
    }).catch(error => {
      setStatusForm({
        status: true,
        message: resource["Form.GenericError"] ?? `Si è verificato un errore, riprova più tardi.`,
        success: false
      });
    })
    .finally(() => {
		appContext._setters._setLoading(false);
    });
  }


  useEffect(() => {
    setResourse(TheApp.Res[TheApp.Locale]);
  }, [resource]);


  return (
    <div className="wrapper-form">
      {loading && <LocalLoading />}
      <form onSubmit={handleSubmit(updateTechnicalInfo)}>
        <div className="row">
          {inputs.map((input, index) => {
            // Hides FITP / FITP EXPIRE DATE for players because it is already visible in user.data
            if(role === "PLAYER" && (input.id == 'fitp'  || input.id == 'FITPExpireDate')) return "";
            return (
              <SingleInput
                key={input.id}
                errors={errors}
                register={register}
                control={control}
                setValue={setValue}
                {...input}
              />
            );
          })}
        </div>
        <input
          value={(resource["Form.Save"]  ?? 'Salva')}
          type="submit"
          className="btn primary"
        />
      </form>
    </div>
  );
}
